import { select } from 'd3-selection';
import { createModalLaunchButton } from './abstract-dialog.mjs';
import { _cloneTemplate } from './utils.mjs';


function listNames(names) {
  if (!names.length) { return ''; }
  if (names.length === 1) { return names[0]; }
  return `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`;
}


function addTimetable(timetable, talks) {
  const rowTemplate = select('#schedule-row-template');
  const streamRowTemplate = select('#schedule-row-stream-template');
  const streamTableTemplate = select('#schedule-stream-table');
  const cloneRow = _cloneTemplate.bind(rowTemplate);
  const cloneStreamRow = _cloneTemplate.bind(streamRowTemplate);
  const cloneStreamTable = _cloneTemplate.bind(streamTableTemplate);
  let captionCounter = 0;

  const createStreamTable = function(container, name, data) {
    const captionId = `stream-table-caption-${++captionCounter}`;
    const table = cloneStreamTable(container).attr('aria-labelledby', captionId);

    const caption = table.select('.pseudocaption');
    if (name) { caption.attr('id', captionId).text(name); }
    else { caption.remove(); }
    
    table.selectAll('.speaker-cell')
      .each(function(_, i) {
        select(this).datum(data[i])
          .classed('tbc', d => !d)
          .each(function(d) {
            const cellSpan = select(this).select('span');
            cellSpan.select('span').text(d => d ? listNames(d.speakers.map(d => d.name)) : 'TBC');
            if (d?.abstract) { createModalLaunchButton(cellSpan, d.id); }
          });
      });
  }

  const tbody = select('#schedule-table tbody');

  timetable.forEach(function(d) {
    const isStream = !!d.streams;
    const row = (isStream ? cloneStreamRow : cloneRow)(tbody);
    row.classed('not-speaker', d.isBreak);
    row.select('.start-time').text(d.startTime);
    row.select('.end-time').text(d.endTime);

    if (d.id) {
      const talkData = talks.get(d.id);
      row.select('.label').text(listNames(talkData.speakers.map(d => d.name)));
      if (talkData.abstract) { createModalLaunchButton(row.select('.label'), d.id) }
    }
    else {
      row.select('.label').text(d.label);
    }

    if (d.streams) {
      const container = row.select('.stream-tables');
      if (d.streams.joint) {
        const data = d.streams.joint.map(d => talks.get(d));
        createStreamTable(container, null, data);
      }
      else {
        const engData = d.streams.eng.map(d => talks.get(d));
        const mlData = d.streams.ml.map(d => talks.get(d));
        createStreamTable(container, 'Engineering stream', engData);
        createStreamTable(container, 'Machine Learning stream', mlData);
      }
    }
  });
}


export { addTimetable };
